<script setup>

/**
 * Page de gestion des vidéos de tutorial
 */

import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useApplicationStore } from '@stores/application';
/***/
import { useAuthUser } from '@compositions/Auth';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const Wrapper = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/Videos/Tutorial/Wrapper'));

const router = useRouter();
const { t } = useI18n();

// Store
const applicationStore = useApplicationStore();

// Application et utilisateur connecté
const currentApplication = computed(() => applicationStore.getCurrent);
const { authUserIsSuperAdmin } = useAuthUser({});

const allowed = ref(false);

onMounted(() => {

    if(! authUserIsSuperAdmin.value) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        const titleKey = 'page.admin.videos.tutorial.list.title';
        document.title = t(titleKey) + ' - ' + currentApplication.value.name;
        allowed.value = true;
    }
});
</script>

<template>
    <layout v-if="allowed">
        <div class="content_header">
            <div class="content-header_title">
                <h1 class="first-title">{{ $t('page.admin.videos.tutorial.list.title') }}</h1>
                <p>{{ $t('page.admin.videos.tutorial.list.description') }}</p>
            </div>
        </div>
        <wrapper></wrapper>
    </layout>
</template>
